import moment from 'moment'

export const startIntercom = (user) => {
  const community = user.communities?.[0]

  window.Intercom('boot', {
    api_base: 'https://api-iam.intercom.io',
    app_id: 'pc5kj7w8',
    action_color: '#ff6633',
    user_id: user.id?.toString(),
    email: user.email,
    name: `${user.first_name} ${user.last_name}`,
    created_at: moment(user.created_at).unix(),
    user_hash: user.intercom_hash,
    user_type: 'Coach',
    lead_coach: user.lead_coach,
    program_advisor: community?.representative_name,
    total_students_in_portal: community?.student_count,
    channel_form_submitted: 'Web App',
    license_plan_type: community?.license_type,
    community_build_date: community ? moment(community.created_at).unix() : undefined,
  })
}

export const stopIntercom = () => {
  window.Intercom('shutdown')
}
